import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-inventor',
  templateUrl: './app-inventor.component.html',
  styleUrls: ['./app-inventor.component.scss'],
})
export class AppInventorComponent implements OnInit {
  modulesText = {
    text: 'Dopo aver preso dimestichezza con la piattaforma, gli studenti potranno affrontare tutte le varie fasi di realizzazione di un’app: ideazione, disegno, sviluppo.',
  };

  constructor() {}

  ngOnInit(): void {}
}
